<script>
export default {
    name: "WhoDropdown"
}
</script>
<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 57.1 57.1" style="enable-background:new 0 0 57.1 57.1;" xml:space="preserve">
        <g>
	<g id="Mask_Group_148_1_" transform="translate(-1002 -1425)">
		<g id="Group_1526_1_" transform="translate(1015 1436.766)">
			<g id="Ellipse_168_1_">
				<circle class="st0" cx="15.5" cy="16.7" r="28.3"/>
                <circle class="st1" cx="15.5" cy="16.7" r="27.8"/>
			</g>
            <g id="Group_1525_1_" transform="translate(3.373 14.319)">
				<g id="Polygon_24_1_" transform="translate(48.915 41.343) rotate(180)">
					<path class="st0" d="M37.2,11.5l24.5,41.3H12.7L37.2,11.5z"/>
                    <path d="M61.2,52.9c0.1-0.1,0.1-0.2,0.2-0.3l-24.3-41L12.7,52.9H61.2z M59.9,51.9H14.5l22.7-38.4L59.9,51.9z"/>
				</g>
                <path id="Path_1360_1_" class="st1" d="M11.7,29v-40.5"/>
			</g>
		</g>
	</g>
</g>
</svg>

</template>
<style lang="css" scoped>
.st0{fill:none;}
.st1{fill:none;stroke:#000000;}
</style>
